"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MegaphonePodcastEpisode1Schema = void 0;
exports.MegaphonePodcastEpisode1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/megaphone-podcast-episode/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MegaphonePodcastEpisode1",
    "description": "Represents a single episode of a podcast hosted on the Megaphone platform (https://megaphone.spotify.com/). This service provides the functionality to embed Megaphone's audio content into your own content, allowing for seamless integration of external podcast episodes.",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:megaphone-podcast-episode:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "organizationId": {
                    "type": "string",
                    "description": "The unique identifier assigned by Megaphone to an organization's account. This can be used to organize and manage podcasts associated with different Red Bull entities, such as Red Bull Racing or Red Bull Illume."
                },
                "podcastId": {
                    "type": "string",
                    "description": "This identifier is used to uniquely identify and access the podcast on the Megaphone platform."
                },
                "episodeId": {
                    "type": "string",
                    "description": "The unique identifier assigned by Megaphone to a specific episode within a podcast. This ID is used to uniquely identify and access the episode on the Megaphone platform."
                },
                "networkId": {
                    "type": "string",
                    "description": "The Megaphone Network ID identifies a so-called \"Network\" within an organisation and is necessary to retrieve any data from Megaphone. All podcast episodes are published in a Network."
                }
            },
            "required": [
                "organizationId",
                "podcastId",
                "episodeId",
                "networkId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9tZWdhcGhvbmUtcG9kY2FzdC1lcGlzb2RlLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsOEJBQThCLEdBQUc7SUFDNUMsS0FBSyxFQUFFLDhGQUE4RjtJQUNyRyxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSwwQkFBMEI7SUFDbkMsYUFBYSxFQUFFLCtRQUErUTtJQUM5UixNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sc0RBQXNEO2FBQ3ZEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osZ0JBQWdCLEVBQUU7b0JBQ2hCLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUscU5BQXFOO2lCQUNyTztnQkFDRCxXQUFXLEVBQUU7b0JBQ1gsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxnR0FBZ0c7aUJBQ2hIO2dCQUNELFdBQVcsRUFBRTtvQkFDWCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLDRLQUE0SztpQkFDNUw7Z0JBQ0QsV0FBVyxFQUFFO29CQUNYLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsMkxBQTJMO2lCQUMzTTthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLGdCQUFnQjtnQkFDaEIsV0FBVztnQkFDWCxXQUFXO2dCQUNYLFdBQVc7YUFDWjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9